import { IAlert } from '../shared/interfaces/IAlert';

/**
 * Creates a generic error alert object.
 *
 * @function
 * @name hCreateGenericErrorAlert
 * @param {Error} error - The error object containing the error details.
 * @param {Object} [additionalInfo] - Optional additional information to include in the alert.
 * @returns {IAlert} - Returns an alert object with error details.
 * @description
 * This function generates a generic error alert object that includes details about the error,
 * such as the error message and stack trace. The alert is configured to never timeout and
 * includes an action to show error details.
 */
export function hCreateGenericErrorAlert(error: Error, additionalInfo?: Object): IAlert {
  return {
    id: `err:${error.name}-${error.message}`,
    type: 'error',
    title: 'Something went wrong!',
    // Never timeout the alert
    timeout: 0,
    canCopy: true,
    details: {
      additionalInfo,
      isCode: true,
      title: error.message,
      description: error.stack,
    },
    actions: [
      {
        text: 'Show Error Details',
        willShowDetailsOnClick: true,
      },
    ],
  };
}
